const SaveFileChromeHelper = {
    isFileSystemAccessSupported() {
        return 'showOpenFilePicker' in self;
    },
    async saveFileChromeHelper(filename, data) {
        if (!SaveFileChromeHelper.isFileSystemAccessSupported()) {
            console.error('File System Access API is not supported in this browser.');
        }

        try {
            const options = {
                suggestedName: filename,
                types: [
                    {
                        description: 'Text Files',
                        accept: {
                            'text/plain': ['.ia'],
                        },
                    },
                ],
            };

            const fileHandle = await self.showSaveFilePicker(options);
            const writable = await fileHandle.createWritable();
            await writable.write(new Blob([data], { type: 'text/plain' }));
            await writable.close();
        } catch (error) {
            console.error('Error saving file:', error);
        }
    },
};

export default SaveFileChromeHelper;
